'use strict';

exports.__esModule = true;
exports.create = create;
exports.get = get;
exports.getActive = getActive;
exports.remove = remove;
exports.setDefault = setDefault;
exports.getStripe = getStripe;

var _http = require('../network/http');

var _http2 = _interopRequireDefault(_http);

var _modelProvider = require('../model-provider');

var _modelProvider2 = _interopRequireDefault(_modelProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  CUSTOMER_CARDS: '/customer/cards',
  CUSTOMER_STRIPE: '/customer/stripe_customer',
  CUSTOMER_STRIPE_DEFAULT: '/customer/stripe_customer/select_card'
};

var cards = { create: create, get: get, remove: remove, setDefault: setDefault, getStripe: getStripe, getActive: getActive };

exports.default = cards;

/**
 * Wrapper for `/customer/cards` API endpoint
 */

/**
 * Create a card
 * @param {Object} attrs - Attributes
 * @param {string} [token] - card token
 * @returns {promise} containing the entity object of the location
 */

function create(attrs) {
  var token = attrs.token;

  return _http2.default.post(API.CUSTOMER_CARDS, { token: token }).then(_modelProvider2.default.Card);
}

/**
 * Gets all customer cards
 * @returns {promise} containing the entity object of the location
 */
function get() {
  // eslint-disable-next-line no-shadow
  return _http2.default.get(API.CUSTOMER_CARDS).then(function (_ref) {
    var _ref$cards = _ref.cards,
        cards = _ref$cards === undefined ? [] : _ref$cards;
    return cards.map(_modelProvider2.default.Card);
  });
}

/**
 * Gets all active customer cards
 * @returns {promise} containing list of Cards
 */
function getActive() {
  return get().then(function (_cards) {
    return _cards.filter(function (card) {
      return !card.expired;
    });
  });
}

/**
 * Remove card from customer account
 * @param {Object} attrs - Attributes
 * @param {string} [id] - card id
 * @returns {promise} containing the entity object of the location
 */
function remove(attrs) {
  var id = attrs.id;

  return _http2.default.remove(API.CUSTOMER_CARDS + '/' + id);
}

/**
 * Updates default card on Stripe
 * @param {Object} attrs - Attributes
 * @param {string} [defaultCard] - card id
 * @returns {promise} containing list of Cards
 */
function setDefault(attrs) {
  var defaultCard = attrs.defaultCard;

  return _http2.default.put(API.CUSTOMER_STRIPE_DEFAULT, { defaultCard: defaultCard }).then(function (_ref2) {
    var _ref2$cards$data = _ref2.cards.data,
        data = _ref2$cards$data === undefined ? [] : _ref2$cards$data;
    return data.map(_modelProvider2.default.Card);
  });
}

/**
 * Gets all customer information from Stripe
 * @returns {promise} containing the entity object of the stripe card
 */
function getStripe() {
  return _http2.default.get(API.CUSTOMER_STRIPE);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/customer/cards.js
// module id = 1087
// module chunks = 0